import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Header as GetiHeader, useTheme } from "@geti/identidade-visual-react";
import { isLoggedIn, logout } from "../../Auth/auth";
import { LuHistory, LuCalendar, LuFileText, LuLogIn } from "react-icons/lu";
import logoDefensoriaSc from "../../Assets/logo-defensoria-sc-branco.png";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setTheme } = useTheme();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const isHome = location.pathname === "/";

  useEffect(() => {
    if (!isHome) {
      setTheme("light");
    }
  }, [isHome, setTheme]);

  if (location.pathname.includes("viewer") || location.pathname === "/login") {
    return null;
  }

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      logout(navigate);
    } finally {
      setIsLoggingOut(false);
    }
  };

  const navItems = isLoggedIn()
    ? [
        {
          href: "/historico",
          label: "Histórico",
          icon: <LuHistory size={20} />,
          onClick: () => navigate("/historico"),
        },
        {
          href: "/agendar",
          label: "Agendar",
          icon: <LuCalendar size={20} />,
          onClick: () => navigate("/agendar"),
        },
        {
          href: "/",
          label: "Atos",
          icon: <LuFileText size={20} />,
          onClick: () => navigate("/"),
        },
      ]
    : [
        {
          href: "/login",
          label: "Entrar",
          icon: <LuLogIn size={20} />,
          onClick: () => navigate("/login"),
        },
      ];

  return (
    <GetiHeader
      publicMode={!isLoggedIn()}
      logoSrc={logoDefensoriaSc}
      logoHref="https://defensoria.sc.def.br/home/"
      navItems={navItems}
      onLogout={isLoggedIn() ? handleLogout : undefined}
      logoutLoading={isLoggingOut}
      hideThemeToggle={!isHome}
    />
  );
};

export default Header;
